export default "__VITE_ASSET__DxKzf9Q___"